import React from "react";
import { Box } from "@material-ui/core";
import AfterSalesSummaryCardsSkeleton from "../AfterSalesSummaryCardsSkeleton/AfterSalesSummaryCardsSkeleton";

// Styles
import useStyles from "./styles";

function AfterSalesSummaryCardListSkeleton({ numberOfCards }) {
  const styles = useStyles();

  const skeletonCards = Array.from({ length: numberOfCards }, (_, index) => (
    <AfterSalesSummaryCardsSkeleton key={index} />
  ));

  return <Box className={styles.root}>{skeletonCards}</Box>;
}

export default AfterSalesSummaryCardListSkeleton;
